/**
 * Leave module UI primitives that reuse the Attendance dashboard theme
 * (att-mvp classes in styles/attendance-mvp.css) so both modules look the same.
 */

/** KPI tone → Attendance KPI variant (indigo / green / red / amber). */
const KPI_TONES = {
  indigo: "employees",
  green: "present",
  red: "absent",
  amber: "leave",
};

export function LeaveKpi({ label, value, hint, suffix, tone = "indigo" }) {
  return (
    <div className={`att-mvp-kpi att-mvp-kpi--${KPI_TONES[tone] || KPI_TONES.indigo}`}>
      <p className="att-mvp-kpi-label">{label}</p>
      <p className="att-mvp-kpi-value">
        {value ?? "—"}
        {suffix ? <span className="lv-att-kpi-suffix">{suffix}</span> : null}
      </p>
      {hint ? <p className="att-mvp-kpi-hint">{hint}</p> : null}
    </div>
  );
}

export function LeaveKpiGrid({ children }) {
  return <div className="att-mvp-kpi-grid">{children}</div>;
}

/** Solid colour tile, same as Attendance "Quick Actions". */
export function LeaveQuickAction({ icon: Icon, label, variant = "mark", onClick }) {
  return (
    <button type="button" onClick={onClick} className={`att-mvp-action att-mvp-action--${variant}`}>
      <Icon size={22} strokeWidth={2} />
      <span className="att-mvp-action-label">{label}</span>
    </button>
  );
}
